import { useState } from 'react';
import { Card, Col, Container, Row, Modal, Carousel, Image } from 'react-bootstrap';
import photos from '../../data/photos.json';
import './Projects.css';

const Projects = () => {
    const [show, setShow] = useState(false);
    const [index, setIndex] = useState(0);

    const handleClose = () => setShow(false);
    const handleShow = (i) => {
      setIndex(i);
      setShow(true);
    };

    const handleSelect = (selectedIndex) => {
      setIndex(selectedIndex);
    };

    return (
        <main className="projects" id="projects">
            <Container>
                <h2>Nuestros proyectos</h2>

                <Row className="g-3">
                    {photos.map((elm, i) => (
                        <Col key={elm.id || i} xs={6} md={4} lg={3}>
                            <Card 
                                className="project-card border-0 shadow-sm overflow-hidden" 
                                onClick={() => handleShow(i)}>
                                    <Image
                                        src={elm.img}
                                        alt={elm.name}
                                        title={elm.name}
                                        fluid
                                        className="project-img"
                                        loading="lazy" />
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>
            <Modal show={show} onHide={handleClose} size="xl" centered className="project-modal">
                <Modal.Header closeButton>
                    <Modal.Title>{photos[index]?.name || 'Proyecto'}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Carousel
                        activeIndex={index}
                        onSelect={handleSelect}
                        interval={null}
                        indicators={photos.length > 1}
                        controls={photos.length > 1}
                        fade>
                            {photos.map((elm, i) => (
                                <Carousel.Item key={i}>
                                    <div className="carousel-slide">
                                        <Image
                                            src={elm.img}
                                            alt={elm.name}
                                            fluid
                                            className="carousel-image" />
                                    </div>
                                    {elm.name && (
                                        <Carousel.Caption>
                                            <h5>{elm.name}</h5>
                                        </Carousel.Caption>
                                    )}
                                </Carousel.Item>
                            ))}
                    </Carousel>
                </Modal.Body>
            </Modal>
        </main>
    )
}

export default Projects